import { Typography } from "@circle-react-uikit/Typography";
import { CheckIcon } from "./CheckIcon";
import { emDash } from "./constants";

interface BooleanFeatureProps {
  value: boolean;
}

export const BooleanFeature = ({ value }: BooleanFeatureProps) =>
  value ? (
    <CheckIcon />
  ) : (
    <Typography.BodyMd color="text-default">{emDash}</Typography.BodyMd>
  );
